/* @flow */

import { message } from '~/common';

export const SOLVE_PAYCHECK_REQUEST = 'SOLVE_PAYCHECK_REQUEST';
export const SOLVE_PAYCHECK_SUCCESS = 'SOLVE_PAYCHECK_SUCCESS';
export const SOLVE_PAYCHECK_FAILURE = 'SOLVE_PAYCHECK_FAILURE';

export function success(payload) {
  message.success('Pendência de contra cheque resolvida');
  return (dispatch) => {
    dispatch({
      type: SOLVE_PAYCHECK_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  message.error('Falha ao resolver pendência');
  return (dispatch) => {
    dispatch({
      type: SOLVE_PAYCHECK_FAILURE,
      payload: resource,
    });
  };
}

export default function uploadHiscon(params) {
  return (dispatch) => {
    dispatch({
      type: SOLVE_PAYCHECK_REQUEST,
      payload: params,
    });
  };
}
